import { type PropsWithChildren } from 'react';
import styled, { css } from 'styled-components';
import type { PositionValue } from '@elfsight/configurator-contracts';
import { zIndexLayer } from '@elfsight/widget-modal';
import type { EmbedRootProps } from '@elfsight/widget-ui';
import { EmbedRoot } from '@elfsight/widget-ui';
import type { WebsiteTranslatorSettings } from '../../../types';
import { positionMixin } from '../position-mixin';
import { transformMixin } from '../transform-mixin';

type EmbedContainerProps = PropsWithChildren<
  EmbedRootProps & {
    embedType: WebsiteTranslatorSettings['embedType'];
    alignment: 'flex-start' | 'flex-end' | 'center';
    position: PositionValue;
    floatingMargin: string;
  }
>;

export function EmbedContainer({
  children,
  embedType,
  alignment,
  position,
  floatingMargin,
  ...forwardingProps
}: EmbedContainerProps) {
  return (
    <StyledEmbedRoot
      {...forwardingProps}
      _embedType={embedType}
      _alignment={alignment}
      _position={position}
      _floatingMargin={floatingMargin}
    >
      {children}
    </StyledEmbedRoot>
  );
}

const StyledEmbedRoot = styled(EmbedRoot)<{
  _embedType: EmbedContainerProps['embedType'];
  _alignment: EmbedContainerProps['alignment'];
  _position: EmbedContainerProps['position'];
  _floatingMargin: EmbedContainerProps['floatingMargin'];
}>`
  && {
    ${({ _embedType, _alignment, _position, _floatingMargin }) => css`
      display: flex;
      flex-direction: column;
      position: relative;
      align-items: ${_alignment};

      ${_embedType === 'floating' &&
      css`
        width: auto;
        z-index: ${zIndexLayer.modal};
        position: fixed;
        margin: ${_floatingMargin};
        ${positionMixin(_position)};
        ${transformMixin(_position)};
      `}
    `}
  }
`;
